// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"501":"bc98253f","3930":"164f4fb6","4316":"ad2866b8"}[chunkId] || chunkId) + "." + {"501":"42fd404a7d9bd986","2931":"5a7e3f80e7128490","3930":"b31aff66bdcce621","4316":"890f6f4190c9fdfb","4374":"2b53b435db993556","6417":"6a59a1c5059bb7ba","6635":"0518191ce933dee1"}[chunkId] + ".js";
};